import { Form, Input } from 'antd';
import React, { FC } from 'react';
import { ISearchData } from 'shared/types/rvd.types';
import { SelectOptions } from '../..';
import style from './index.module.scss';

type TProps = {
  onSearch: (data: string, key: keyof ISearchData) => void;
};

const IdSearch: FC<TProps> = ({ onSearch }) => {
  return (
    <Form.Item name={SelectOptions.ID_OPTION} className={style.searchInput}>
      <Input.Search
        type="number"
        placeholder="Поиск по номеру заявки"
        allowClear
        onSearch={val => onSearch(val, 'byId')}
      />
    </Form.Item>
  );
};

export default IdSearch;
